import PropTypes from "prop-types";
import React, { useEffect } from "react";
import styled from "styled-components";

const Nav = ({ className, progress, active, fullpageApi }) => {
  return (
    <div className={`${className}`}>
      <div className="container feature-wrapper">
        <div className="zorb-container">
          <div className={`zorb ${active === "preparation" ? "active" : ""}`}>
            <p>Sample preparation just like qPCR experiments</p>
            <div
              className="play"
              onClick={() => {
                fullpageApi.moveSectionDown();
              }}
            >
              <img
                src={require(`../images/play.svg`).default}
                className="icon"
                alt="play"
              />
            </div>
          </div>
        </div>
        <div className="zorb-link">
          <span>Load the plate and walk away</span>
        </div>
        <div className="zorb-container">
          <div className={`zorb ${active === "partitioning" ? "active" : ""}`}>
            <p>
              Partitioning, thermocycling and imaging - all integrated in a single
              fully automated instrument
            </p>
            <div
              className="play"
              onClick={() => {
                fullpageApi.moveSectionDown();
              }}
            >
              <img
                src={require(`../images/play.svg`).default}
                className="icon"
                alt="play"
              />
            </div>
          </div>
        </div>
        <div className="zorb-link">
          <span>Run completed</span>
        </div>
        <div className="zorb-container">
          <div className={`zorb ${active === "analysis" ? "active" : ""}`}>
            <p>Analyze results and visualize data using the Suite Software</p>
            <div
              className="play"
              onClick={() => {
                fullpageApi.moveSectionDown();
              }}
            >
              <img
                src={require(`../images/play.svg`).default}
                className="icon"
                alt="play"
              />
            </div>
          </div>
          <h3 className="text-muted">Under 2 h to results</h3>
        </div>
      </div>
    </div>
  );
};

Nav.propTypes = {
  siteTitle: PropTypes.string
};

Nav.defaultProps = {
  siteTitle: ``
};

const StyledNav = styled(Nav)`
  position: relative;
  z-index: 10;
  margin-top: -120px;
  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    margin-top: 130px!important;
  }
  @media (min-width: ${p => p.theme.break}px) {
    padding: 0 50px;
  }

  @media (max-width: ${p => p.theme.break}px) {
    transform: translateY(40px);
  }

  .feature-wrapper {
    padding: 0px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%!important;
  }
  .feature-wrapper i {
    color: white;
  }

  .zorb-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
  }
  .zorb-container h3 {
    font-size: 1rem;
    position: absolute;
    left: -50%;
    bottom: -50px;
    width: 200%;
    text-align: center;
    padding: 0 10%;
    color: ${p => p.theme.colors.link};
  }

  .zorb {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background-color: #fff;

    border: 1px solid ${p => p.theme.colors.link};
    transition: 300ms all ease-in-out;
    -webkit-backface-visibility: hidden;
    @media (min-width: ${p => p.theme.break}px) {
      width: 150px;
      height: 150px;
    }

    p {
      font-size: 0.9rem !important;
      line-height: 1.2 !important;
      transform: scale(0.55);
      transition: 300ms all ease-in-out;
      -webkit-backface-visibility: hidden;
      color: ${p => p.theme.colors.link};
      width: 100%;
      @media (min-width: ${p => p.theme.break}px) {
        transform: scale(0.5);
        font-size: 1rem important;;
      }
    }

    .play {
      position: absolute;
      left: 100%;
      bottom: 50%;
      margin-left: -12px;
      margin-bottom: -22px;
      width: 44px;
      height: 44px;
      border-radius: 50%;
      background: ${p => p.theme.colors.highlight};
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: 300ms all ease-in-out;
      transform: scale(0);

      @media (min-width: ${p => p.theme.break}px) {
        left: 50%;
        bottom: -22px;
        margin-left: -22px;
        margin-bottom: 0px;
      }
    }

    &.active {
      width: 175px;
      height: 175px;
      background-color: #e9eef2;
      padding: 20px 10px 20px 35px;

      .play {
          transform: scale(1);
        }

        @media (min-width: ${p => p.theme.break}px) {
          width: 225px;
          height: 225px;
          background-color: #e9eef2;
          padding: 30px 30px 30px 50px;
        }

        p {
          transform: scale(1);
          transition-delay: 0.2s;
        }
      }
    }

    .zorb-link {
      width: 0px;
      height: 30px;
      border-bottom: 0px;
      border-right: 1px solid ${p => p.theme.colors.link};
      flex-grow: 1;
      position: relative;
      display: flex;
      align-items: center;

      &:before {
        content: "";
        position: absolute;
        left: -5px;
        top: -6px;
        width: 11px;
        height: 11px;
        border-radius: 50%;
        background: ${p => p.theme.colors.link};
      }

      &:after {
        content: "";
        position: absolute;
        right: -7px;
        bottom: -1px;
        width: 0;
        height: 0;
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        border-top: 11px solid ${p => p.theme.colors.link};
      }
      clear: both;
      z-index: 9999;
    }

    span {
      position: absolute;
      left: 20px;
      top: 8px;
      width: 200px;
      padding: 0px;
      font-size: 0.8rem !important;
      line-height: 1.2 !important;

      color: ${p => p.theme.colors.link};

      @media (min-width: ${p => p.theme.break}px) {
        text-align: center;
        left: 0;
        top: 20px;
        width: 100%;
        padding: 0 5%;
        font-size: 1rem !important;
      }
    }
  }

  @media (min-width: ${p => p.theme.break}px) {
    .feature-wrapper {
      flex-direction: row;
    }

    .zorb-link {
      height: 0px;
      border-bottom: 1px solid ${p => p.theme.colors.link};
      margin-bottom: 0px;
      max-width: 200px;
      max-height: 50px;
      &:before {
        content: "";
        position: absolute;
        left: -6px;
        bottom: -6px;
        width: 11px;
        height: 11px;
        border-radius: 50%;
        background: ${p => p.theme.colors.link};
      }

      &:after {
        content: "";
        position: absolute;
        right: -7px;
        top: -5px;
        width: 0;
        height: 0;
        border-top: 6px solid transparent;
        border-bottom: 6px solid transparent;
        border-left: 11px solid ${p => p.theme.colors.link};
        clear: both;
        z-index: 9999;
      }
    }
  }
`;

export default StyledNav;
